import React from "react";
import {
  Button,
  Col,
  FormGroup,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";

import { DataTable } from "../revel-strap";

import { numberFunc } from "../../utils";

import { UserModel, TeamListModel } from "../../models";

const user_model = new UserModel();
const team_list_model = new TeamListModel();

class ProductModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      is_loading: true,
      data_buffers: [],
      users: [],
    };
  }

  componentDidUpdate(props_old) {
    if (!props_old.is_show && this.props.is_show) {
      this.setState({ data_buffers: [] }, () => {
        this._fetchData();
      });
    }
  }

  _fetchData = (params = { pagination: { current: 1, pageSize: 20 } }) =>
    this.setState({ is_loading: true }, async () => {
      const userLists = this.props.user_lists;
      const teamLength = this.props.team_length;
      const userDeleteLists = this.props.user_delete_lists;
      let users = await user_model.getUserBy({ user_branch_code: this.props.team_branch_code });
      let team_lists = await team_list_model.getTeamListBy();
      let arrUser = [];
      let arrUserCode = [];
      let userList = [];
      let useUsed = 0;

      team_lists.data.map((item, key) => {
        let checkUserCode = userDeleteLists.indexOf(item.user_code);
        if (checkUserCode == -1) {
          arrUserCode.push(item.user_code);
        }
      });

      users.data.map((item, key) => {
        let checkUserCode = arrUserCode.indexOf(item.user_code);
        if (checkUserCode == -1) {
          userList.push(item);
        } else {
          useUsed += 1;
        }
      });

      if (userLists.length > 0 || userList.length > 0) {
        if (
          userList.length == userLists.length - teamLength ||
          (userDeleteLists.length == 0 &&
            users.data.length == userLists.length - teamLength + useUsed)
        ) {
          userList = [];
          arrUser = [];
          users = [];
        } else {
          userList.map((item, key) => {
            let checkUserCode = userLists.indexOf(item.user_code);
            if (checkUserCode == -1) {
              arrUser.push(item);
            }
          });
        }
      }

      this.setState({
        is_loading: false,
        users: arrUser.length > 0 ? arrUser : userList,
      });
    });

  _handleConfirm = () => this.props.onConfirm(this.state.data_buffers);
  _handleClose = () => this.props.onClose();

  render() {
    return (
      <Modal
        size="xl"
        centered
        isOpen={this.props.is_show}
        toggle={this._handleClose}
      >
        <ModalHeader toggle={this._handleClose}>เลือกรายการ</ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <FormGroup>
                <div
                  className="alert-box alert-info"
                  style={{ height: 36, padding: 8 }}
                >
                  ทั้งหมด : {this.state.users.total} รายการ
                </div>
              </FormGroup>
            </Col>
          </Row>
          <DataTable
            loading={this.state.is_loading}
            onChange={this._fetchData}
            dataSource={
              this.state.users.data ? this.state.users.data : this.state.users
            }
            dataTotal={this.state.users.total}
            setProps={{
              rowSelection: {
                type: "checkbox",
                preserveSelectedRowKeys: true,
                onChange: (selectedRowKeys, selectedRows) =>
                  this.setState({ data_buffers: selectedRows }),
              },
            }}
            rowKey="user_code"
            columns={[
              {
                title: "รหัสผู้ใช้",
                dataIndex: "user_code",
                filterAble: true,
                ellipsis: true,
                width: 160,
              },
              {
                title: "ชื่อผู้ใช้",
                dataIndex: "user_full_name",
                filterAble: true,
                ellipsis: true,
              },
            ]}
          />
        </ModalBody>
        <ModalFooter>
          <div
            className="flex-grow-1 alert-success"
            style={{ height: 36, padding: 8 }}
          >
            เลือก : {this.state.data_buffers.length} รายการ
          </div>
          <Button type="button" color="primary" onClick={this._handleConfirm}>
            ยืนยันรายการ
          </Button>
          <Button type="button" onClick={this._handleClose}>
            ยกเลิก
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default ProductModal;
